import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar';
import TopBar from '../TopBar';
import { FaBars } from 'react-icons/fa';
import { CompanyProvider } from '../../context/CompanyContext';
import { ensureAuth, getEulaStatus } from '../utils/eula';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [eulaGate, setEulaGate] = useState('checking');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check for user authentication in localStorage
    const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
    if (!pbAuth?.record) {
      // If no user record found, redirect to login
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    const record = ensureAuth();
    if (!record?.id) return undefined;

    let cancelled = false;
    (async () => {
      try {
        const status = await getEulaStatus(record.id);
        if (cancelled) return;
        const mustAccept = status.required && !status.accepted && !status.collectionMissing && !status.lookupError;
        setEulaGate(mustAccept ? 'required' : 'ok');
        if (mustAccept && location.pathname !== '/change-password') {
          navigate('/change-password', { replace: true });
        }
      } catch (error) {
        if (!cancelled) setEulaGate('ok');
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, navigate]);

  // Get user record from localStorage
  const pbAuth = JSON.parse(localStorage.getItem('pocketbase_auth') || '{}');
  const userRecord = pbAuth?.record;

  // If no user record, don't render anything (will redirect in useEffect)
  if (!userRecord) {
    return null;
  }

  return (
    <CompanyProvider>
      <div className="flex h-screen bg-[#f5f6fa]">
        {/* Mobile Sidebar Toggle - Only show when sidebar is closed */}
        {!sidebarOpen && (
          <button
            className="lg:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-[#101828] text-white"
            onClick={() => setSidebarOpen(true)}
          >
            <FaBars />
          </button>
        )}

        {/* Sidebar */}
        <div className={`fixed lg:static inset-y-0 left-0 z-40 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0 transition-transform duration-300 ease-in-out`}>
          <Sidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-w-0">
          <TopBar />
          <main className="flex-1 overflow-y-auto bg-[#f5f6fa] p-4 md:p-6 lg:p-8">
            {eulaGate === 'checking' || (eulaGate === 'required' && location.pathname !== '/change-password') ? (
              <div className="p-6">
                <div className="h-8 w-48 bg-gray-200 rounded animate-pulse mb-4" />
                <div className="h-40 bg-white rounded-lg border border-gray-100 animate-pulse" />
              </div>
            ) : (
              children
            )}
          </main>
        </div>

        {/* Overlay for mobile */}
        {sidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
      </div>
    </CompanyProvider>
  );
};

export default MainLayout; 